import { render, staticRenderFns } from "./PageLocations.vue?vue&type=template&id=7cafdba6&"
import script from "./PageLocations.vue?vue&type=script&lang=js&"
export * from "./PageLocations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports